import { useState } from "react";
import { useRole } from "@/data/RoleContext";
import { ExecutiveCommandCenter } from "@/components/dashboards/ExecutiveCommandCenter";
import { OperationsCommandCenter } from "@/components/dashboards/OperationsCommandCenter";
import { InstallerDashboard } from "@/components/dashboards/InstallerDashboard";
import { SubcontractorDashboard } from "@/components/dashboards/SubcontractorDashboard";
import { SalesCommandCenter } from "@/components/dashboards/SalesCommandCenter";
import { WarehouseCommandCenter } from "@/components/dashboards/WarehouseCommandCenter";
import { CFOCommandCenter } from "@/components/dashboards/CFOCommandCenter";
import { InstallSupplyChainCommandCenter } from "@/components/dashboards/InstallSupplyChainCommandCenter";
import { PipelineView } from "@/components/dashboards/PipelineView";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { LayoutDashboard, GitBranch } from "lucide-react";

export default function Dashboard() {
  const { role } = useRole();

  if (role === "super_admin" || role === "owner") {
    return <SuperAdminDashboard />;
  }

  switch (role) {
    case "cfo":
    case "finance_manager":
    case "bookkeeper":
      return <CFOCommandCenter />;
    case "ops_manager":
    case "admin":
    case "it_staff":
      return <OperationsCommandCenter />;
    case "warehouse_manager":
      return <WarehouseCommandCenter />;
    case "head_of_installation":
    case "procurement_manager":
    case "inventory_manager":
      return <InstallSupplyChainCommandCenter />;
    case "installer":
      return <InstallerDashboard />;
    case "subcontractor":
      return <SubcontractorDashboard />;
    case "sales":
    case "sales_manager":
    case "call_center":
      return <SalesCommandCenter />;
    default:
      return <ExecutiveCommandCenter />;
  }
}

function SuperAdminDashboard() {
  return (
    <Tabs defaultValue="modules" className="space-y-4 overflow-x-hidden">
      <TabsList className="max-w-full overflow-x-auto whitespace-nowrap">
        <TabsTrigger value="modules" className="gap-1.5">
          <LayoutDashboard className="h-3.5 w-3.5" />
          Module View
        </TabsTrigger>
        <TabsTrigger value="pipeline" className="gap-1.5">
          <GitBranch className="h-3.5 w-3.5" />
          Pipeline View
        </TabsTrigger>
      </TabsList>

      <TabsContent value="modules">
        <ExecutiveCommandCenter />
      </TabsContent>

      <TabsContent value="pipeline">
        <PipelineView />
      </TabsContent>
    </Tabs>
  );
}
